/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_Team_ConflictInputs */

const en_inbox_na_team_conflict = /** @type {(inputs: Inbox_Na_Team_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolve the team conflict`)
};

const id_inbox_na_team_conflict = /** @type {(inputs: Inbox_Na_Team_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selesaikan bentrok tim`)
};

/**
* | output |
* | --- |
* | "Resolve the team conflict" |
*
* @param {Inbox_Na_Team_ConflictInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_team_conflict = /** @type {((inputs?: Inbox_Na_Team_ConflictInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Team_ConflictInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_team_conflict(inputs)
	return en_inbox_na_team_conflict(inputs)
});